import React, { useState, useEffect, useRef } from "react";
import { Clock } from "lucide-react";

export const CustomTimePicker = ({ value, onChange, options, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const pickerRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (time) => {
    onChange({ target: { value: time } });
    setIsOpen(false);
  };

  return (
    <div className="w-32" ref={pickerRef}>
      <div className="relative">
        {/* Icon: If using RTL (Arabic/Hebrew), ensure 'left-3' is switched to 'right-3' or use 'rtl:right-3' */}
        <Clock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-[#ca8032] pointer-events-none" />

        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="w-full border border-gray-300 rounded-md pl-10 pr-4 pt-5 pb-1 text-base text-left h-14 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none bg-white truncate"
        >
          {value}
        </button>

        {/* Label: Same RTL note applies here */}
        <label className="absolute left-10 top-2 text-xs text-[#ca8032] pointer-events-none">
          {label}
        </label>

        {isOpen && (
          // FIX APPLIED HERE: Replaced 'custom-time-dropdown' with Tailwind classes
          <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
            {options.map((time) => (
              <div
                key={time}
                // FIX APPLIED HERE: Replaced 'time-slot' with Tailwind classes
                className="cursor-pointer px-4 py-2 hover:bg-orange-50 text-sm text-gray-700 transition-colors"
                onClick={() => handleSelect(time)}
              >
                {time}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
